import script from "./Classifications.vue?vue&type=script&setup=true&lang=js"
export * from "./Classifications.vue?vue&type=script&setup=true&lang=js"

export default script